"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { ArrowLeft } from "@/components/icons";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { PREV_PATH_KEY } from "@/components/site/navigation-tracker";
import { PATH_BACK_LABELS } from "@/lib/constants";

interface PostBreadcrumbProps {
  backHref: string;
  backLabel: string;
  current: string;
  color?: string;
  className?: string;
}

export default function PostBreadcrumb({
  backHref,
  backLabel,
  current,
  color,
  className,
}: PostBreadcrumbProps) {
  const router = useRouter();
  const [label, setLabel] = useState(backLabel);
  const [canGoBack, setCanGoBack] = useState(false);

  useEffect(() => {
    const prev = sessionStorage.getItem(PREV_PATH_KEY);
    if (!prev) return;
    const path = prev.replace(/\/$/, "") || "/";
    const resolved = PATH_BACK_LABELS[path]?.replace("Back to ", "");
    if (resolved) setLabel(resolved);
    setCanGoBack(true);
  }, []);

  const handleBack = () => (canGoBack ? router.back() : router.push(backHref));

  return (
    <Breadcrumb className={className}>
      <BreadcrumbList className="text-xs">
        <BreadcrumbItem>
          <button
            type="button"
            onClick={handleBack}
            className="text-muted-foreground hover:text-foreground flex cursor-pointer items-center gap-1 transition-colors"
          >
            <ArrowLeft size={12} />
            {label}
          </button>
        </BreadcrumbItem>
        {current && (
          <>
            <BreadcrumbSeparator>/</BreadcrumbSeparator>
            <BreadcrumbItem>
              <BreadcrumbPage style={color ? { color } : undefined}>{current}</BreadcrumbPage>
            </BreadcrumbItem>
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
